export const messages = {
    en: {
        actionBar: {
            bar: { inProgress: 'Drafts', latest: 'Closed Reports' },
            sideMenu: {
                saveModifications: 'Save Modifications',
                reportOverview: 'Condition Report Overview',
                signReport: 'Sign Condition Report',
                closeReport: 'Close Condition Report',
                printReport: 'Print Condition Report',
                deleteReport: 'Delete current Condition Report'
            }
        },
        auth: {
            login: {
                error: {
                    credentials: 'Username and/or password incorrect',
                    network: 'Communication with server has failed'
                },
                form: {
                    password: { error: 'Please enter your username', label: 'Password' },
                    submit: 'Log in',
                    submitting: 'Logging in',
                    username: { error: 'Please enter your password', label: 'Username' }
                }
            },
            renew: {
                slowNetwork: 'This is taking more time than usual. Please do not quit the application.',
                spinner: 'Getting you back online'
            }
        },
        closeReportScreen: {
            important: 'IMPORTANT',
            close: 'Close Condition Report',
            title: 'Close Condition Report',
            notificationContent: "The report '{referenceNumber}' has been closed",
            warningMessage: 'Once closed, the Condition Report cannot be modified nor deleted ',
            warningQuestion: 'Are you sure that you want to close the Condition Report?',
            transferingFile: 'Transfering PDF document...',
            fileGeneration: 'Generating final PDF document...',
            reportClosing: 'Closing the current condition report...'
        },
        defectTree: {
            alteration: {
                alterationLabel: 'Type of Damage: ',
                alterationsTitle: 'Damages: ',
                createAlterationButtonLabel: 'Damage',
                levelTitle: 'Level 3',
                precisionLabel: 'Detail:',
                deleteConfirmationMessage: 'Confirm deletion of damage',
                precisionPlaceholder: 'Select sub-category',
                thesaurusTermWarningMessage: 'The selected damage does not match the material',
                typeOfAlterationPlaceholder: 'Select type of Observation'
            },
            annotation: {
                annotationsTitle: 'Annotations:',
                commentsPlaceholder: 'Precise…',
                deleteConfirmationMessage: 'Confirm deletion ?'
            },
            defect: {
                createElementButtonLabel: 'Zone',
                deleteConfirmationMessage: 'Confirm deletion of zone',
                elementLabel: 'Zone:',
                precisionLabel: 'Detail',
                elementPlaceholder: 'Name of Element',
                precisionPlaceholder: 'Précisez...'
            },
            material: {
                createMaterialButtonLabel: 'Material ',
                deleteConfirmationMessage: 'Confirm deletion of material',
                levelTitle: 'Level 2',
                materialLabel: 'Material:',
                materialsTitle: 'Materials:',
                thesaurusTermWarningMessage: 'The selected material does not match the type of observation'
            },
            observation: {
                createObservationButtonLabel: 'Observation',
                deleteConfirmationMessage: 'Confirm deletion of observation',
                levelTitle: 'Level 1',
                observationLabel: 'Type of Observation:',
                observationsTitle: 'Observations:'
            },
            submit: 'Save modifications',
            submitError: 'Defects could not be updated',
            submitting: 'Saving…'
        },
        drawingEditor: {
            title: 'Detailed Damage',
            imageTitlePlaceholder: 'Type image caption',
            observationLabel: 'Obs.{index}',
            observationPlaceholder: 'Enter Observation',
            validate: 'Save'
        },
        editReportScreen: {
            reportTitlePrefix: 'Report N° {refNumber}',
            reportStatusInProgress: 'In Progress',
            reportIdentifiers: {
                accordionPanelTitle: 'GENERAL INFORMATION',
                referenceNumber: 'Reference Number',
                numberingInformation: 'Leave this field blank to activate the automated numbering once the report has been saved',
                otherIdentifiers: 'Other Identifiers',
                reportReason: 'Reason of Condition Report',
                precision: 'Detail',
                reportType: 'Report type',
                reportTypePlaceholder: 'Select a report type'
            },
            reportContext: {
                accordionPanelTitle: 'CONTEXT',
                reportDate: 'Date of report',
                reportDoneInThePresenceOf: 'Report written in the presence of',
                andOf: 'and',
                name: 'Name/Surname, Role',
                role: 'Role',
                coordinates: 'Contact info',
                email: 'Email',
                signer: 'Persons authorized to sign the report',
                reportPlace: 'Place',
                customer: 'Customer',
                precisions: 'Details',
                linkedProject: 'Related Project',
                linkedMovement: 'Related Movement',
                technicsAndMaterials: 'Techniques and Materials',
                comments: 'Comments'
            },
            alterations: { accordionPanelTitle: 'DAMAGES' },
            conservation: { accordionPanelTitle: 'CONSERVATION AND MANIPULATION' },
            observations: {
                accordionPanelTitle: 'GENERAL OBSERVATIONS & RECOMMENDATIONS',
                commentsFieldLabel: 'Comments',
                interventionToSchedule: 'Scheduled interventions',
                interventionToSchedulePlaceholder: 'Choose an intervention',
                interventionToSchedulePrecision: 'Précision :',
                stateOfConservation: 'State of conservation',
                stateOfConservationPlaceholder: 'Choose a state',
                treatmentPriority: 'Treatment priority',
                treatmentPriorityPlaceholder: 'Choose a priority'
            },
            medias: { accordionPanelTitle: 'ATTACHED MULTIMEDIA' },
            saveAlert: {
                errorMessage: 'An error occurred when saving the Condition Report',
                successMessage: 'Condition Report has been saved'
            },
            deleteAlert: {
                errorMessage: 'An error occurred when deleting the Condition Report',
                successMessage: 'Condition Report has been deleted'
            }
        },
        firewall: {
            collabWarningMessage: "Your account doesn't any associated collaborator, the app may be disfunctionning",
            noGroupForUserWarningMessage: 'You user account needs to be part of group of users to be able to user SKINreporter'
        },
        listReportScreen: {
            closed: {
                downloadFailure: 'An error occured during the document downloading',
                downloadSuccess: 'The document {docTitle} has been dowloaded',
                open: 'OPEN DOCUMENT',
                title: 'Completed Condition Reports'
            },
            inProgress: { edit: 'EDIT CONDITION REPORT', title: 'Drafts' },
            concernedItem: 'Related Objects',
            nbResults: '{nbResults} Results',
            noResults: 'No Results'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Deployment',
                checkForUpdate: {
                    help: 'If an update is available, it will be installed automatically.',
                    title: 'Please check for updates'
                },
                clearCache: {
                    help: 'If you are offline, this process will remove access to all data stored on your device',
                    title: 'Clear cache memory'
                },
                overrideLocale: {
                    help: 'The english langage will be used and your device’s settings will be ignored',
                    title: 'Force english langage'
                },
                resetLocaleOverride: {
                    help: 'The langage will depend on your device’s settings',
                    title: 'Reset the language'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Are you sure that you want to log out?'
        },
        offlineRibbon: { offline: 'You are now offline' },
        pdfOverviewScreen: {
            download: 'Download',
            progressBar: {
                mainLabel: 'Preparing document',
                object: 'Object',
                generalDigest: 'General Observations',
                defects: 'Damages',
                contextAndSignatures: 'Context and Signatures',
                documentReady: 'Document is now ready!'
            },
            title: 'Overview'
        },
        pdfDocument: {
            mainTitlePrefix: 'CONDITION REPORT - ',
            objectSection: {
                sectionTitle: 'Object',
                inventoryNumber: 'Inventory Number : ',
                title: 'Title : ',
                author: 'Artist / Author :',
                creationDate: 'Creation date : ',
                typology: 'Typology : ',
                denomination: 'Denomination : ',
                materialsAndTechniques: 'Materials and techniques :',
                dimensions: 'Dimensions : ',
                institution: 'Institution :'
            },
            alterationsSection: {
                detailedAlteration: 'Damage details',
                noAnnotation: 'No annotation to display',
                observationLabel: 'Obs.',
                sectionTitle: 'Damages details'
            },
            finalObservationsSection: { sectionTitle: 'Final observations' },
            contextSection: {
                comments: 'Comments :',
                matAndTechs: 'Technics and materials :',
                reportDate: 'Report date :',
                reportPlace: 'Report place :',
                reportReference: 'Report reference :',
                sectionTitle: 'Context',
                reportType: 'Report type : ',
                reportReason: 'Reason of condition report : '
            },
            reportSection: {
                interventionsToSchedule: 'Interventions to schedule : ',
                sectionTitle: 'Report',
                signatoriesTitle: 'Report made in presence of :',
                stateOfConservation: 'State of conservation : ',
                treatmentPriority: 'Treatment priority : '
            },
            footer: { prefix: 'CONDITION REPORT', separator: '- Page ' }
        },
        proxy: {
            error: {
                default: 'An error occured on the resource {uri}',
                network: 'Communication with the server has failed',
                notFound: 'The resource {uri} could not be found',
                tokenHasExpired: 'Your session has expired'
            }
        },
        search: {
            noResults: 'No Results',
            options: {
                sortType: {
                    creationDate: 'Date of Creation',
                    identifier: 'Main identifier',
                    lastModification: 'Last Modification',
                    mainTitle: 'Main Title',
                    referenceNumber: 'Reference number'
                }
            },
            queryPlaceholder: 'Search',
            title: 'Objects',
            totalCount: '{totalResults}  Result(s) : 1 - {nbResults}'
        },
        searchFeaturedCard: {
            createNewReport: 'CREATE NEW CONDITION REPORT',
            createNewReportFromLast: 'CREATE CONDITION REPORT USING THE LATEST REPORT',
            institutionLabel: 'Institution',
            lastReportLabel: 'Latest Condition Report',
            materialsAndTechniques: 'Materials / Techniques',
            measurements: 'Measurements',
            noLinkedItem: 'No item is linked to this condition report'
        },
        serviceWorker: {
            updateAvailable: 'An update has been installed. You can either click here to refresh the page or restart the application.'
        },
        signatureModuleScreen: {
            cardTitle: 'Signatory ',
            eraseSignature: 'Clear Signature',
            missingSignature: 'The Condition Report has not been signed',
            nameLabel: 'Name  / Surname',
            presentSignature: 'The Condition Report has been signed',
            saveSignature: 'Save',
            signatureStatus: 'Status of Signature',
            title: 'Signatures'
        }
    },
    fr: {
        actionBar: {
            bar: { inProgress: 'En cours', latest: 'Terminés' },
            sideMenu: {
                saveModifications: 'Sauvegarder les modifications',
                reportOverview: "Aperçu du constat d'état",
                signReport: "Signer le constat d'état",
                closeReport: "Clôturer le constat d'état",
                printReport: "Imprimer le constat d'état",
                deleteReport: 'Supprimer le constat en cours'
            }
        },
        auth: {
            login: {
                error: {
                    credentials: 'Vos identifiants sont incorrects',
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    password: {
                        error: "Veuillez saisir votre nom d'utilisateur",
                        label: 'Mot de passe'
                    },
                    submit: 'Se connecter',
                    submitting: 'Connexion...',
                    username: {
                        error: 'Veuillez saisir votre mot de passe',
                        label: "Nom d'utilisateur"
                    }
                }
            },
            renew: {
                slowNetwork: "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                spinner: 'Nous vous reconnectons...'
            }
        },
        closeReportScreen: {
            important: 'IMPORTANT',
            close: 'Clôturer',
            title: "Clôture du constat d'état",
            notificationContent: "Le constat '{referenceNumber}' a été clôturé",
            warningMessage: 'Un constat clôturé ne peut être modifié ni supprimé',
            warningQuestion: "Souhaitez-vous réellement poursuivre la clôture du constat d'état ?",
            transferingFile: 'Transfert du document PDF...',
            fileGeneration: 'Génération du document pdf final...',
            reportClosing: "Clôture du constat d'état..."
        },
        defectTree: {
            alteration: {
                alterationLabel: 'Type :',
                alterationsTitle: 'Altérations :',
                createAlterationButtonLabel: 'Alteration',
                levelTitle: 'Niveau 3',
                precisionLabel: 'Précision :',
                deleteConfirmationMessage: "Confirmer la suppression de l'altération et de son contenu ?",
                precisionPlaceholder: 'Sélectionnez un sous-type',
                thesaurusTermWarningMessage: "Le type d'altération sélectionné ne correspond pas au matériau ci-dessus",
                typeOfAlterationPlaceholder: "Sélectionnez un type d'observation"
            },
            annotation: {
                annotationsTitle: 'Annotations :',
                commentsPlaceholder: 'Précisez...',
                deleteConfirmationMessage: 'Confirmer la suppression ?'
            },
            defect: {
                createElementButtonLabel: 'Élément',
                deleteConfirmationMessage: "Confirmer la suppression de l'élément et de son contenu ?",
                elementLabel: 'Elément :',
                precisionLabel: 'Précision',
                elementPlaceholder: "Nom de l'élément",
                precisionPlaceholder: 'Précisez...'
            },
            material: {
                createMaterialButtonLabel: 'Matériau',
                deleteConfirmationMessage: 'Confirmer la suppression du matériau et de son contenu ?',
                levelTitle: 'Niveau 2',
                materialLabel: 'Matériau :',
                materialsTitle: 'Matériaux :',
                thesaurusTermWarningMessage: "Le matériau sélectionné ne correspond pas au type d'observation ci-dessus"
            },
            observation: {
                createObservationButtonLabel: 'Observation',
                deleteConfirmationMessage: "Confirmer la suppression de l'observation et de son contenu ?",
                levelTitle: 'Niveau 1',
                observationLabel: "Type d'observation :",
                observationsTitle: 'Observations :'
            },
            submit: 'Sauvegarder les modifications',
            submitError: "L'arbre n'a pas pu être mis à jour",
            submitting: 'Sauvegarde en cours...'
        },
        drawingEditor: {
            title: 'Altération détaillée',
            imageTitlePlaceholder: "Saisir la légende de l'image",
            observationLabel: 'Obs.{index}',
            observationPlaceholder: 'Entrez une observation',
            validate: 'Enregistrer'
        },
        editReportScreen: {
            reportTitlePrefix: 'Constat N° {refNumber}',
            reportStatusInProgress: 'En cours',
            reportIdentifiers: {
                accordionPanelTitle: 'IDENTIFIANTS DU CONSTAT',
                referenceNumber: 'N° de référence',
                numberingInformation: 'Laisser vide pour activer la numérotation automatique à la prochaine sauvegarde',
                otherIdentifiers: 'Autres identifants',
                reportReason: 'Motif du constat',
                precision: 'Précision',
                reportType: 'Type de constat',
                reportTypePlaceholder: 'Sélectionnez un type de constat'
            },
            reportContext: {
                accordionPanelTitle: "CONTEXTE DU CONSTAT D'ÉTAT",
                reportDate: 'Date du constat',
                reportDoneInThePresenceOf: 'Constat effectué en présence de',
                andOf: 'Et de',
                name: 'Nom/Prénom, Qualité',
                role: 'Qualité',
                coordinates: 'Coordonnées',
                email: 'Email',
                signer: 'Signataire',
                reportPlace: 'Lieu du constat',
                customer: 'Client/Commanditaire',
                precisions: 'Précisions',
                linkedProject: 'Projet Lié',
                linkedMovement: 'Mouvement Lié',
                technicsAndMaterials: 'Techniques et matériels utilisés',
                comments: 'Commentaires'
            },
            alterations: { accordionPanelTitle: 'ALTÉRATIONS' },
            conservation: { accordionPanelTitle: 'CONSERVATION ET MANIPULATION' },
            observations: {
                accordionPanelTitle: 'RAPPORT ET OBSERVATIONS',
                commentsFieldLabel: 'Commentaires',
                interventionToSchedule: 'Interventions à prévoir',
                interventionToSchedulePlaceholder: 'Choisissez une intervention',
                interventionToSchedulePrecision: 'Précision :',
                stateOfConservation: 'Etat du bien',
                stateOfConservationPlaceholder: 'Choisissez un état',
                treatmentPriority: 'Priorité de traitement',
                treatmentPriorityPlaceholder: 'Choississez une priorité'
            },
            medias: { accordionPanelTitle: 'MÉDIAS' },
            saveAlert: {
                errorMessage: 'Une erreur est survenue pendant la sauvegarde du constat',
                successMessage: "Constat d'état sauvegardé"
            },
            deleteAlert: {
                errorMessage: 'Une erreur est survenue pendant la suppression du constat',
                successMessage: "Constat d'état supprimé"
            }
        },
        firewall: {
            collabWarningMessage: "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            noGroupForUserWarningMessage: "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        listReportScreen: {
            closed: {
                downloadFailure: 'Une erreur est survenue pendant le téléchargement',
                downloadSuccess: 'Le document {docTitle} a été téléchargé',
                open: 'TÉLÉCHARGER LE DOCUMENT',
                title: "Constats d'état terminés"
            },
            inProgress: {
                edit: 'EDITER LE CONSTAT',
                title: "Constats d'état en cours d'édition"
            },
            concernedItem: 'Objet de musée concerné',
            nbResults: '{nbResults} résultats',
            noResults: 'Aucun résultat'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Déployé le',
                checkForUpdate: {
                    help: "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    title: 'Vérifiez les mises à jour'
                },
                clearCache: {
                    help: "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    title: 'Vider le cache'
                },
                overrideLocale: {
                    help: 'La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.',
                    title: 'Forcer la langue anglaise'
                },
                resetLocaleOverride: {
                    help: 'La langue utilisé dépendra du paramètrage de votre terminal',
                    title: 'Réinitialiser la langue'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Etes-vous sûr de vouloir vous déconnecter ?'
        },
        offlineRibbon: { offline: 'Vous êtes hors connexion' },
        pdfOverviewScreen: {
            download: 'Télécharger',
            progressBar: {
                mainLabel: 'Génération du document ...',
                object: 'Objet',
                generalDigest: 'Appréciation Générale',
                defects: 'Altérations',
                contextAndSignatures: 'Contexte et signatures',
                documentReady: 'Document prêt !'
            },
            title: 'Aperçu'
        },
        pdfDocument: {
            mainTitlePrefix: "CONSTAT D'ETAT - ",
            objectSection: {
                sectionTitle: 'Objet',
                inventoryNumber: "N° d'inventaire : ",
                title: 'Titre : ',
                author: 'Artiste / Auteur :',
                creationDate: 'Date de création : ',
                typology: 'Typologie : ',
                denomination: 'Dénomination : ',
                materialsAndTechniques: 'Matériaux et techniques :',
                dimensions: 'Dimensions : ',
                institution: 'Institution :'
            },
            alterationsSection: {
                detailedAlteration: 'Altération détaillée',
                noAnnotation: 'Aucune annotation à afficher',
                observationLabel: 'Obs.',
                sectionTitle: 'Détail des altérations'
            },
            finalObservationsSection: { sectionTitle: 'Observations finales' },
            contextSection: {
                comments: 'Commentaires :',
                matAndTechs: 'Matériaux et techniques :',
                reportDate: 'Date du constat :',
                reportPlace: 'Lieu : ',
                reportReference: 'Référence du constat :',
                sectionTitle: "Contexte du présent constat d'état",
                reportType: 'Type de constat : ',
                reportReason: 'Motif du constat : '
            },
            reportSection: {
                interventionsToSchedule: 'Interventions à prévoir : ',
                sectionTitle: 'Rapport',
                signatoriesTitle: 'Constat effectué en présence de :',
                stateOfConservation: 'Etat du bien : ',
                treatmentPriority: 'Priorité de traitement : '
            },
            footer: { prefix: "CONSTAT D'ETAT", separator: '- Page ' }
        },
        proxy: {
            error: {
                default: "Une erreur s'est produite sur la ressource {uri}",
                network: 'La communication avec le serveur a échoué',
                notFound: "La ressource {uri} n'a pas été trouvée",
                tokenHasExpired: 'Votre session a expiré'
            }
        },
        search: {
            noResults: 'Aucun résultat',
            options: {
                sortType: {
                    creationDate: 'Date de création',
                    identifier: 'Identifiant principal',
                    lastModification: 'Dernière modification',
                    mainTitle: 'Titre principal',
                    referenceNumber: 'Numéro de référence'
                }
            },
            queryPlaceholder: 'Mots clés ou N° Inventaire',
            title: 'Objets de musée',
            totalCount: '{totalResults}  Résultat(s) : 1 -'
        },
        searchFeaturedCard: {
            createNewReport: 'CRÉER UN NOUVEAU CONSTAT',
            createNewReportFromLast: 'CONSTAT À PARTIR DU DERNIER CONSTAT',
            institutionLabel: 'Institution',
            lastReportLabel: "Dernier constat d'état",
            materialsAndTechniques: 'Matériaux / Techniques',
            measurements: 'Dimensions',
            noLinkedItem: "Aucun item n'est lié à ce constat d'état"
        },
        serviceWorker: {
            updateAvailable: "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
        },
        signatureModuleScreen: {
            cardTitle: 'Signataire',
            eraseSignature: 'Signer à nouveau',
            missingSignature: 'Signature manquante',
            nameLabel: 'Nom / Prénom',
            presentSignature: 'Signature présente',
            saveSignature: 'Enregistrer',
            signatureStatus: 'Statut de la signature',
            title: 'Signatures'
        }
    },
    "fr-ca": {
        countryCode: "ca",
        actionBar: {
            bar: { inProgress: 'En cours', latest: 'Terminés' },
            sideMenu: {
                saveModifications: 'Sauvegarder les modifications',
                reportOverview: "Aperçu du constat d'état",
                signReport: "Signer le constat d'état",
                closeReport: "Clôturer le constat d'état",
                printReport: "Imprimer le constat d'état",
                deleteReport: "Supprimer le constat en cours",
            }
        },
        auth: {
            login: {
                error: {
                    credentials: 'Vos identifiants sont incorrects',
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    password: {
                        error: "Veuillez saisir votre nom d'utilisateur",
                        label: 'Mot de passe'
                    },
                    submit: 'Se connecter',
                    submitting: 'Connexion...',
                    username: {
                        error: 'Veuillez saisir votre mot de passe',
                        label: "Nom d'utilisateur"
                    }
                }
            },
            renew: {
                slowNetwork: "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                spinner: 'Nous vous reconnectons...'
            }
        },
        closeReportScreen: {
            important: 'IMPORTANT',
            close: 'Clôturer',
            title: "Clôture du constat d'état",
            notificationContent: "Le constat '{referenceNumber}' a été clôturé",
            warningMessage: 'Un constat clôturé ne peut être modifié ni supprimé',
            warningQuestion: "Souhaitez-vous réellement poursuivre la clôture du constat d'état ?",
            transferingFile: 'Transfert du document PDF...',
            fileGeneration: 'Génération du document pdf final...',
            reportClosing: "Clôture du constat d'état..."
        },
        defectTree: {
            alteration: {
                alterationLabel: 'Type :',
                alterationsTitle: 'Altérations :',
                createAlterationButtonLabel: 'Alteration',
                levelTitle: 'Niveau 3',
                precisionLabel: 'Précision :',
                deleteConfirmationMessage: "Confirmer la suppression de l'altération et de son contenu ?",
                precisionPlaceholder: 'Sélectionnez un sous-type',
                thesaurusTermWarningMessage: "Le type d'altération sélectionné ne correspond pas au matériau ci-dessus",
                typeOfAlterationPlaceholder: "Sélectionnez un type d'observation"
            },
            annotation: {
                annotationsTitle: 'Annotations :',
                commentsPlaceholder: 'Précisez...',
                deleteConfirmationMessage: 'Confirmer la suppression ?'
            },
            defect: {
                createElementButtonLabel: 'Élément',
                deleteConfirmationMessage: "Confirmer la suppression de l'élément et de son contenu ?",
                elementLabel: 'Elément :',
                precisionLabel: 'Précision',
                elementPlaceholder: "Nom de l'élément",
                precisionPlaceholder: 'Précisez...'
            },
            material: {
                createMaterialButtonLabel: 'Matériau',
                deleteConfirmationMessage: 'Confirmer la suppression du matériau et de son contenu ?',
                levelTitle: 'Niveau 2',
                materialLabel: 'Matériau :',
                materialsTitle: 'Matériaux :',
                thesaurusTermWarningMessage: "Le matériau sélectionné ne correspond pas au type d'observation ci-dessus"
            },
            observation: {
                createObservationButtonLabel: 'Observation',
                deleteConfirmationMessage: "Confirmer la suppression de l'observation et de son contenu ?",
                levelTitle: 'Niveau 1',
                observationLabel: "Type d'observation :",
                observationsTitle: 'Observations :'
            },
            submit: 'Sauvegarder les modifications',
            submitError: "L'arbre n'a pas pu être mis à jour",
            submitting: 'Sauvegarde en cours...'
        },
        drawingEditor: {
            title: 'Altération détaillée',
            imageTitlePlaceholder: "Saisir la légende de l'image",
            observationLabel: 'Obs.{index}',
            observationPlaceholder: 'Entrez une observation',
            validate: 'Enregistrer'
        },
        editReportScreen: {
            reportTitlePrefix: 'Constat N° {refNumber}',
            reportStatusInProgress: 'En cours',
            reportIdentifiers: {
                accordionPanelTitle: 'IDENTIFIANTS DU CONSTAT',
                referenceNumber: 'N° de référence',
                numberingInformation: 'Laisser vide pour activer la numérotation automatique à la prochaine sauvegarde',
                otherIdentifiers: 'Autres identifants',
                reportReason: 'Motif du constat',
                precision: 'Précision',
                reportType: "Type de constat",
                reportTypePlaceholder: "Sélectionnez un type de constat"

            },
            reportContext: {
                accordionPanelTitle: "CONTEXTE DU CONSTAT D'ÉTAT",
                reportDate: 'Date du constat',
                reportDoneInThePresenceOf: 'Constat effectué en présence de',
                andOf: 'Et de',
                name: 'Nom/Prénom, Qualité',
                role: 'Qualité',
                coordinates: 'Coordonnées',
                email: 'Email',
                signer: 'Signataire',
                reportPlace: 'Lieu du constat',
                customer: 'Client/Commanditaire',
                precisions: 'Précisions',
                linkedProject: 'Projet Lié',
                linkedMovement: 'Mouvement Lié',
                technicsAndMaterials: 'Techniques et matériels utilisés',
                comments: 'Commentaires'
            },
            alterations: { accordionPanelTitle: 'ALTÉRATIONS' },
            conservation: { accordionPanelTitle: 'CONSERVATION ET MANIPULATION' },
            observations: {
                accordionPanelTitle: 'RAPPORT ET OBSERVATIONS',
                commentsFieldLabel: 'Commentaires',
                interventionToSchedule: 'Interventions à prévoir',
                interventionToSchedulePlaceholder: 'Choisissez une intervention',
                interventionToSchedulePrecision: "Précision :",
                stateOfConservation: 'Etat du bien',
                stateOfConservationPlaceholder: 'Choisissez un état',
                treatmentPriority: 'Priorité de traitement',
                treatmentPriorityPlaceholder: 'Choississez une priorité'
            },
            medias: { accordionPanelTitle: 'MÉDIAS' },
            saveAlert: {
                errorMessage: 'Une erreur est survenue pendant la sauvegarde du constat',
                successMessage: "Constat d'état sauvegardé"
            },
            deleteAlert: {
                errorMessage: "Une erreur est survenue pendant la suppression du constat",
                successMessage: "Constat d'état supprimé",
            }
        },
        firewall: {
            collabWarningMessage: "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            noGroupForUserWarningMessage: "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        listReportScreen: {
            closed: {
                downloadFailure: 'Une erreur est survenue pendant le téléchargement',
                downloadSuccess: 'Le document {docTitle} a été téléchargé',
                open: 'TÉLÉCHARGER LE DOCUMENT',
                title: "Constats d'état terminés"
            },
            inProgress: {
                edit: 'EDITER LE CONSTAT',
                title: "Constats d'état en cours d'édition"
            },
            concernedItem: 'Objet de musée concerné',
            nbResults: '{nbResults} résultats',
            noResults: 'Aucun résultat'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Déployé le',
                checkForUpdate: {
                    help: "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    title: 'Vérifiez les mises à jour'
                },
                clearCache: {
                    help: "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    title: 'Vider le cache'
                },
                overrideLocale: {
                    help: 'La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.',
                    title: 'Forcer la langue anglaise'
                },
                resetLocaleOverride: {
                    help: 'La langue utilisé dépendra du paramètrage de votre terminal',
                    title: 'Réinitialiser la langue'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Etes-vous sûr de vouloir vous déconnecter ?'
        },
        offlineRibbon: { offline: 'Vous êtes hors connexion' },
        pdfOverviewScreen: {
            download: 'Télécharger',
            progressBar: {
                mainLabel: 'Génération du document ...',
                object: 'Objet',
                generalDigest: 'Appréciation Générale',
                defects: 'Altérations',
                contextAndSignatures: 'Contexte et signatures',
                documentReady: 'Document prêt !'
            },
            title: 'Aperçu'
        },
        pdfDocument: {
            mainTitlePrefix: "CONSTAT D'ETAT - ",
            objectSection: {
                sectionTitle: 'Objet',
                inventoryNumber: "N° d'inventaire : ",
                title: 'Titre : ',
                author: 'Artiste / Auteur :',
                creationDate: 'Date de création : ',
                typology: 'Typologie : ',
                denomination: 'Dénomination : ',
                materialsAndTechniques: 'Matériaux et techniques :',
                dimensions: 'Dimensions : ',
                institution: 'Institution :'
            },
            alterationsSection: {
                detailedAlteration: 'Altération détaillée',
                noAnnotation: 'Aucune annotation à afficher',
                observationLabel: 'Obs.',
                sectionTitle: 'Détail des altérations',
            },
            finalObservationsSection: { sectionTitle: 'Observations finales' },
            contextSection: {
                sectionTitle: "Contexte du présent constat d'état",
                reportDate: 'Date du constat :',
                reportReference: 'Référence du constat :',
                comments: "Commentaires :",
                matAndTechs: "Matériaux et techniques :",
                reportPlace: "Lieu : ",
                reportType: "Type de constat : ",
                reportReason: "Motif du constat : "
            },
            reportSection: {
                interventionsToSchedule: 'Interventions à prévoir : ',
                sectionTitle: 'Rapport',
                signatoriesTitle: 'Constat effectué en présence de :',
                stateOfConservation: 'Etat du bien : ',
                treatmentPriority: 'Priorité de traitement : '
            },
            footer: { prefix: "CONSTAT D'ETAT", separator: '- Page ' }
        },
        proxy: {
            error: {
                default: "Une erreur s'est produite sur la ressource {uri}",
                network: 'La communication avec le serveur a échoué',
                notFound: "La ressource {uri} n'a pas été trouvée",
                tokenHasExpired: 'Votre session a expiré'
            }
        },
        search: {
            noResults: 'Aucun résultat',
            options: {
                sortType: {
                    creationDate: 'Date de création',
                    identifier: 'Identifiant principal',
                    lastModification: 'Dernière modification',
                    mainTitle: 'Titre principal',
                    referenceNumber: 'Numéro de référence',
                }
            },
            queryPlaceholder: 'Mots clés ou N° Inventaire',
            title: 'Objets de musée',
            totalCount: '{totalResults}  Résultat(s) : 1 -'
        },
        searchFeaturedCard: {
            createNewReport: 'CRÉER UN NOUVEAU CONSTAT',
            createNewReportFromLast: 'CONSTAT À PARTIR DU DERNIER CONSTAT',
            institutionLabel: 'Institution',
            lastReportLabel: "Dernier constat d'état",
            materialsAndTechniques: 'Matériaux / Techniques',
            measurements: 'Dimensions',
            noLinkedItem: "Aucun item n'est lié à ce constat d'état"

        },
        serviceWorker: {
            updateAvailable: "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
        },
        signatureModuleScreen: {
            cardTitle: 'Signataire',
            eraseSignature: 'Signer à nouveau',
            missingSignature: 'Signature manquante',
            nameLabel: 'Nom / Prénom',
            presentSignature: 'Signature présente',
            saveSignature: 'Enregistrer',
            signatureStatus: 'Statut de la signature',
            title: 'Signatures'
        }
    },
    nl: {
        actionBar: {
            bar: {
                inProgress: 'Schetsen',
                latest: 'Gesloten rapporten / Rapporten gesloten'
            },
            sideMenu: {
                saveModifications: 'Bewaar wijzigingen',
                reportOverview: 'Overzicht van het conditierapport',
                signReport: 'Onderteken conditierapport',
                closeReport: 'Sluit conditierapport',
                printReport: 'Druk conditierapport af',
                deleteReport: 'Verwijder huidig conditierapport'
            }
        },
        auth: {
            login: {
                error: {
                    credentials: 'Gebruikersnaam en/of paswoord niet correct',
                    network: 'Communicatie met server mislukt'
                },
                form: {
                    password: {
                        error: 'Gelieve uw gebruikersnaam in te voeren',
                        label: 'Paswoord'
                    },
                    submit: 'Inloggen',
                    submitting: 'Aan het inloggen…',
                    username: {
                        error: 'Gelieve uw paswoord in te voeren',
                        label: 'Gebruikersnaam'
                    }
                }
            },
            renew: {
                slowNetwork: 'Dit duurt langer dan gebruikelijk. Gelieve de toepassing niet te sluiten.',
                spinner: 'We brengen u terug online '
            }
        },
        closeReportScreen: {
            important: 'BELANGRIJK',
            close: 'Sluit conditierapport',
            title: 'Sluit conditierapport',
            notificationContent: "Het rapport '{referenceNumber}' werd gesloten",
            warningMessage: 'Eens gesloten kan het conditierapport niet meer gewijzigd of verwijderd worden',
            warningQuestion: 'Bent u zeker dat u het conditierapport wil sluiten?',
            transferingFile: 'Pdf-document aan het overzetten…',
            fileGeneration: 'Finale pdf wordt aangemaakt',
            reportClosing: 'Sluiten van het huidige conditierapport…'
        },
        defectTree: {
            alteration: {
                alterationLabel: 'Soort beschadiging:',
                alterationsTitle: 'Beschadigingen: ',
                createAlterationButtonLabel: 'Beschadiging',
                levelTitle: 'Niveau 3',
                precisionLabel: 'Detail:',
                deleteConfirmationMessage: 'Bevestig schrapping van de schade',
                precisionPlaceholder: 'Selecteer subcategorie',
                thesaurusTermWarningMessage: 'De geselecteerde beschadiging komt niet overeen met de soort materiaal',
                typeOfAlterationPlaceholder: 'Selecteer soort observatie'
            },
            annotation: {
                annotationsTitle: 'Annotatie',
                commentsPlaceholder: 'Verduidelijk',
                deleteConfirmationMessage: 'Bevestig schrapping?'
            },
            defect: {
                createElementButtonLabel: 'Zone',
                deleteConfirmationMessage: 'Bevestig schrapping van de zone',
                elementLabel: 'Zone:',
                precisionLabel: 'Detail',
                elementPlaceholder: 'Naam van het element',
                precisionPlaceholder: 'Verduidelijk'
            },
            material: {
                createMaterialButtonLabel: 'Materiaal',
                deleteConfirmationMessage: 'Bevestig schrapping van het materiaal',
                levelTitle: 'Niveau 2',
                materialLabel: 'Materiaal:',
                materialsTitle: 'Materialen:',
                thesaurusTermWarningMessage: 'Het geselecteerde materiaal komt niet overeen met het soort observatie'
            },
            observation: {
                createObservationButtonLabel: 'Observatie',
                deleteConfirmationMessage: 'Bevestig schrapping van de observatie',
                levelTitle: 'Niveau 1',
                observationLabel: 'Soort observatie:',
                observationsTitle: 'Observaties:'
            },
            submit: 'Bewaar wijzigingen',
            submitError: 'De boomstructuur werd niet geüpdatet',
            submitting: 'Bewaren in verwerking…'
        },
        drawingEditor: {
            title: 'Gedetailleerde beschadiging:',
            imageTitlePlaceholder: 'Soort beeldbijschrift/Voer beeldbijschrift in',
            observationLabel: 'Obs.{index}',
            observationPlaceholder: 'Voer observatie in',
            validate: 'Bewaar'
        },
        editReportScreen: {
            reportTitlePrefix: 'Rapportnummer {refNumber}',
            reportStatusInProgress: 'In verwerking',
            reportIdentifiers: {
                accordionPanelTitle: 'ALGEMENE INFORMATIE',
                referenceNumber: 'Referentienummer',
                numberingInformation: 'Laat dit veld leeg om de automatische nummering te activeren van zodra het rapport is bewaard',
                otherIdentifiers: 'Andere identificatoren',
                reportReason: 'Reden conditierapport',
                precision: 'Detail',
                reportType: 'Rapporttype',
                reportTypePlaceholder: 'Selecteer een rapporttype'
            },
            reportContext: {
                accordionPanelTitle: 'CONTEXT',
                reportDate: 'Datum van het rapport',
                reportDoneInThePresenceOf: 'Rapport geschreven in aanwezigheid van',
                andOf: 'en',
                name: 'Familienaam / Voornaam, Rol/Functie',
                role: 'Rol/Functie',
                coordinates: 'Contactgegevens',
                email: 'E-mail',
                signer: 'Personen die gemachtigd zijn om het rapport te ondertekenen',
                reportPlace: 'Plaats',
                customer: 'Klant',
                precisions: 'Details',
                linkedProject: 'Gerelateerd project',
                linkedMovement: 'Gerelateerde verplaatsing',
                technicsAndMaterials: 'Technieken en materialen',
                comments: 'Opmerkingen'
            },
            alterations: { accordionPanelTitle: 'BESCHADIGINGEN' },
            conservation: { accordionPanelTitle: 'CONSERVATIE EN MANIPULATIE' },
            observations: {
                accordionPanelTitle: 'ALGEMENE INFORMATIE & AANBEVELINGEN',
                commentsFieldLabel: 'Opmerkingen',
                interventionToSchedule: 'Geplande interventies',
                interventionToSchedulePlaceholder: 'Kies een interventie',
                interventionToSchedulePrecision: 'Detail :',
                stateOfConservation: 'Conservatiestaat',
                stateOfConservationPlaceholder: 'Kies een staat',
                treatmentPriority: 'Behandelprioriteit',
                treatmentPriorityPlaceholder: 'Kies een prioriteit'
            },
            medias: { accordionPanelTitle: 'BIJGEVOEGDE MULTIMEDIA' },
            saveAlert: {
                errorMessage: 'Error bij het bewaren van het conditierapport',
                successMessage: 'Conditierapport werd bewaard'
            },
            deleteAlert: {
                errorMessage: 'Error bij het verwijderen van het conditierapport',
                successMessage: 'Conditierapport werd verwijderd'
            }
        },
        firewall: {
            collabWarningMessage: 'MISSING TRANSLATION',
            noGroupForUserWarningMessage: 'MISSING TRANSLATION'
        },
        listReportScreen: {
            closed: {
                downloadFailure: 'Error bij het downloaden van het document',
                downloadSuccess: 'Het document {docTitle} werd gedownload',
                open: 'Document openen',
                title: 'Afgewerkte conditierapporten'
            },
            inProgress: { edit: 'BEWERK CONDITIERAPPORT', title: 'Schetsen' },
            concernedItem: 'Gerelateerde objecten',
            nbResults: '{nbResults} Resultaten',
            noResults: 'Geen resultaten'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Ingezet/Ontwikkeld op:',
                checkForUpdate: {
                    help: 'Als een update beschikbaar is, zal die automatisch worden geïnstalleerd.',
                    title: 'Gelieve te controleren op updates'
                },
                clearCache: {
                    help: 'Als u offline bent, heeft u niet langer toegang tot alle gegevens die op uw toestel zijn opgeslagen.',
                    title: 'Maak cache (tijdelijk geheugen) leeg'
                },
                overrideLocale: {
                    help: 'Het Engels zal worden gebruikt en de instellingen van uw apparaat zullen worden genegeerd.',
                    title: 'Het Engels forceren'
                },
                resetLocaleOverride: {
                    help: 'De gebruikte taal zal afhangen van de instellingen van uw terminal',
                    title: 'Stel taal opnieuw in'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Bent u zeker dat u wil uitloggen?'
        },
        offlineRibbon: { offline: 'U bent nu offline' },
        pdfOverviewScreen: {
            download: 'Download',
            progressBar: {
                mainLabel: 'Document wordt voorbereid',
                object: 'Object',
                generalDigest: 'Algemene informatie',
                defects: 'Beschadiging',
                contextAndSignatures: 'Context en handtekeningen',
                documentReady: 'Document is klaar!'
            },
            title: 'Overzicht'
        },
        pdfDocument: {
            mainTitlePrefix: 'CONDITIERAPPORT - ',
            objectSection: {
                sectionTitle: 'Object',
                inventoryNumber: 'Inventarisnummer:',
                title: 'Titel:',
                author: 'Kunstenaar / Auteur:',
                creationDate: 'Aanmaakdatum:',
                typology: 'Typologie:',
                denomination: 'Benaming:',
                materialsAndTechniques: 'Materialen en technieken:',
                dimensions: 'Afmetingen:',
                institution: 'Instelling:'
            },
            alterationsSection: {
                detailedAlteration: 'Details van de beschadiging',
                noAnnotation: 'Geen annotatie om te tonen',
                observationLabel: 'Obs.',
                sectionTitle: 'Details van de beschadigingen'
            },
            finalObservationsSection: { sectionTitle: 'Finale observaties' },
            contextSection: {
                comments: 'Opmerkingen:',
                matAndTechs: 'Materialen en technieken:',
                reportDate: 'Datum van het rapport:',
                reportPlace: 'Plaats van het rapport:',
                reportReference: 'Rapportreferentie:',
                sectionTitle: 'Context',
                reportType: 'Rapporttype:',
                reportReason: 'Reden conditierapport:'
            },
            reportSection: {
                interventionsToSchedule: 'Interventies om in te plannen:',
                sectionTitle: 'Rapport',
                signatoriesTitle: 'Rapport opgemaakt in aanwezigheid van:',
                stateOfConservation: 'Conservatiestaat',
                treatmentPriority: 'Behandelprioriteit:'
            },
            footer: { prefix: 'CONDITIERAPPORT', separator: ' - Pagina' }
        },
        proxy: {
            error: {
                default: 'Error bij de hulpbron {uri}',
                network: 'Communicatie met server mislukt',
                notFound: 'De oplossing {uri} kon niet worden gevonden',
                tokenHasExpired: 'Uw sessie is vervallen'
            }
        },
        search: {
            noResults: 'Geen resultaten',
            options: {
                sortType: {
                    creationDate: 'Aanmaakdatum',
                    identifier: 'Hoofdidentificator',
                    lastModification: 'Laatste wijziging',
                    mainTitle: 'Hoofdtitel',
                    referenceNumber: 'Referentienummer'
                }
            },
            queryPlaceholder: 'Zoekopdracht',
            title: 'Objecten',
            totalCount: '{totalResults}  Resulta(a)t(en) : 1 -'
        },
        searchFeaturedCard: {
            createNewReport: 'MAAK NIEUW CONDITIERAPPORT AAN',
            createNewReportFromLast: 'MAAK CONDITIERAPPORT AAN OP BASIS VAN HET LAATSTE RAPPORT',
            institutionLabel: 'Instelling',
            lastReportLabel: 'Laatste conditierapport',
            materialsAndTechniques: 'Materialen / Technieken',
            measurements: 'Afmetingen',
            noLinkedItem: 'Er is geen item gelinkt aan dit conditierapport'
        },
        serviceWorker: {
            updateAvailable: 'Update werd geïnstalleerd. U kunt ofwel hier klikken om de pagina te vernieuwen ofwel de toepassing opnieuw opstarten'
        },
        signatureModuleScreen: {
            cardTitle: 'Ondertekenaar',
            eraseSignature: 'Haal handtekening weg',
            missingSignature: 'Het conditierapport werd niet ondertekend',
            nameLabel: 'Familienaam / Voornaam',
            presentSignature: 'Het conditierapport werd ondertekend',
            saveSignature: 'Bewaar',
            signatureStatus: 'Status/Statuut van de handtekening',
            title: 'Handtekeningen'
        }
    },
    es: {
        actionBar: {
            bar: { inProgress: 'En curso', latest: 'Completado' },
            sideMenu: {
                saveModifications: 'Salvaguardar los cambios',
                reportOverview: 'Resumen del informe de estado',
                signReport: 'Firmar el informe de estado',
                closeReport: 'Cerrar el informe de condiciones',
                printReport: 'Imprimir el informe de estado',
                deleteReport: 'Eliminar el informe actual'
            }
        },
        auth: {
            login: {
                error: {
                    credentials: 'Sus datos de acceso son incorrectos',
                    network: 'La comunicación con el servidor ha fallado'
                },
                form: {
                    password: {
                        error: 'Por favor, introduzca su nombre de usuario',
                        label: 'Contraseña'
                    },
                    submit: 'Entrar en el sistema',
                    submitting: 'Conectando...',
                    username: {
                        error: 'Por favor, introduzca su contraseña',
                        label: 'Nombre de usuario'
                    }
                }
            },
            renew: {
                slowNetwork: 'Si parece que tarda más de lo habitual, no abandones la aplicación.',
                spinner: 'Le reconectamos...'
            }
        },
        closeReportScreen: {
            important: 'IMPORTANTE',
            close: 'Cerrar',
            title: 'Cierre del informe de situación',
            notificationContent: "El informe '{referenceNumber}' ha sido cerrado",
            warningMessage: 'Un informe cerrado no puede modificarse ni borrarse',
            warningQuestion: '¿Realmente quiere perseguir el cierre del informe de condiciones?',
            transferingFile: 'Transferir el documento PDF...',
            fileGeneration: 'Generación del documento pdf final...',
            reportClosing: 'El cierre del informe estado...'
        },
        defectTree: {
            alteration: {
                alterationLabel: 'Tipo:',
                alterationsTitle: 'Alteraciones :',
                createAlterationButtonLabel: 'Alteración',
                levelTitle: 'Nivel 3',
                precisionLabel: 'Aclaración:',
                deleteConfirmationMessage: '¿Confirmar la supresión de la alteración y su contenido?',
                precisionPlaceholder: 'Seleccione un subtipo',
                thesaurusTermWarningMessage: 'El tipo de alteraciónseleccionado no coincide con el material anterior',
                typeOfAlterationPlaceholder: 'Seleccione un tipo de observación'
            },
            annotation: {
                annotationsTitle: 'Anotaciones :',
                commentsPlaceholder: 'Especifica...',
                deleteConfirmationMessage: '¿Confirmar el borrado?'
            },
            defect: {
                createElementButtonLabel: 'Elemento',
                deleteConfirmationMessage: '¿Confirmar la eliminación del elemento y su contenido?',
                elementLabel: 'Elemento:',
                precisionLabel: 'Precisión',
                elementPlaceholder: 'Nombre del elemento',
                precisionPlaceholder: 'Especifica...'
            },
            material: {
                createMaterialButtonLabel: 'Material',
                deleteConfirmationMessage: '¿Confirmar la supresión del material y su contenido?',
                levelTitle: 'Nivel 2',
                materialLabel: 'Material:',
                materialsTitle: 'Materiales :',
                thesaurusTermWarningMessage: 'El material seleccionado no coincide con el tipo de observación anterior'
            },
            observation: {
                createObservationButtonLabel: 'Observación',
                deleteConfirmationMessage: '¿Confirmar la supresión del comentario y su contenido?',
                levelTitle: 'Nivel 1',
                observationLabel: 'Tipo de observación :',
                observationsTitle: 'Observaciones:'
            },
            submit: 'Guardar los cambios',
            submitError: 'El árbol no ha podido ser actualizado',
            submitting: 'Copia de seguridad en curso...'
        },
        drawingEditor: {
            title: 'Alteración detallada',
            imageTitlePlaceholder: 'Introduzca el título de la imagen',
            observationLabel: 'Obs {index}',
            observationPlaceholder: 'Introduzca un comentario',
            validate: 'Salvaguardar'
        },
        editReportScreen: {
            reportTitlePrefix: 'Informe nº {refNumber}',
            reportStatusInProgress: 'En curso',
            reportIdentifiers: {
                accordionPanelTitle: 'IDENTIFICADORES DE INFORMES',
                referenceNumber: 'Número de referencia',
                numberingInformation: 'Dejar en blanco para activar la marcación automática en el siguiente guardado',
                otherIdentifiers: 'Otros identificadores',
                reportReason: 'Motivo del informe',
                precision: 'Precisión',
                reportType: 'Tipo de hallazgo',
                reportTypePlaceholder: 'Seleccione un tipo de informe'
            },
            reportContext: {
                accordionPanelTitle: 'CONTEXTO DEL INFORME DE ESTADO',
                reportDate: 'Fecha del informe',
                reportDoneInThePresenceOf: 'Observación realizada en presencia de',
                andOf: 'Y de',
                name: 'Apellidos/Nombre, Cargo',
                role: 'Calidad',
                coordinates: 'Datos de contacto',
                email: 'Direccion electrónica',
                signer: 'Firmante',
                reportPlace: 'Localización del informe',
                customer: 'Cliente/Comprador',
                precisions: 'Detalles',
                linkedProject: 'Proyecto relacionado',
                linkedMovement: 'Movimiento vinculado',
                technicsAndMaterials: 'Técnicas y materiales utilizados',
                comments: 'Comentarios'
            },
            alterations: { accordionPanelTitle: 'ALTERACIONES' },
            conservation: { accordionPanelTitle: 'CONSERVACIÓN Y MANIPULACIÓN' },
            observations: {
                accordionPanelTitle: 'INFORME Y COMENTARIOS',
                commentsFieldLabel: 'Comentarios',
                interventionToSchedule: 'Intervenciones a planificar',
                interventionToSchedulePlaceholder: 'Elija una intervención',
                interventionToSchedulePrecision: 'Aclaración:',
                stateOfConservation: 'Estado del inmueble',
                stateOfConservationPlaceholder: 'Elija un estado',
                treatmentPriority: 'Prioridad de tratamiento',
                treatmentPriorityPlaceholder: 'Elija una prioridad'
            },
            medias: { accordionPanelTitle: 'MEDIA' },
            saveAlert: {
                errorMessage: 'Se ha producido un error al guardar el informe',
                successMessage: 'Informe de estado guardado'
            },
            deleteAlert: {
                errorMessage: 'Se ha producido un error al borrar el informe',
                successMessage: 'Informe de estado borrado'
            }
        },
        firewall: {
            collabWarningMessage: 'Su cuenta no tiene un colaborador asociado, la aplicación puede funcionar mal',
            noGroupForUserWarningMessage: 'El uso de SKINreporter requiere que su cuenta de usuario esté vinculada a un grupo de usuarios'
        },
        listReportScreen: {
            closed: {
                downloadFailure: 'Se ha producido un error durante la descarga',
                downloadSuccess: 'El documento {docTitle} ha sido descargado',
                open: 'DESCARGAR EL DOCUMENTO',
                title: 'Informes de estado completados'
            },
            inProgress: {
                edit: 'EDITAR EL INFORME',
                title: 'Informes de estado que se emiten'
            },
            concernedItem: 'Objeto del museo en cuestión',
            nbResults: '{nbResults} resultados',
            noResults: 'No hay resultados'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Desplegado en',
                checkForUpdate: {
                    help: 'Si hay una actualización disponible, se instalará automáticamente.',
                    title: 'Comprobar las actualizaciones'
                },
                clearCache: {
                    help: 'Si estás sin conexión, esto elimina el acceso a todos los datos almacenados en el dispositivo.',
                    title: 'Vaciar la caché'
                },
                overrideLocale: {
                    help: 'Se utilizará el idioma inglés y se ignorará la configuración de su terminal.',
                    title: 'Forzar el idioma inglés'
                },
                resetLocaleOverride: {
                    help: 'El idioma utilizado dependerá de la configuración de su terminal',
                    title: 'Restablecer el idioma'
                },
                title: 'Skin-REPORTER'
            },
            logout: '¿Está seguro de que quiere desconectarte?'
        },
        offlineRibbon: { offline: 'Usted está fuera de línea' },
        pdfOverviewScreen: {
            download: 'Descargar',
            progressBar: {
                mainLabel: 'Generación de documentos ...',
                object: 'Objeto',
                generalDigest: 'Apreciación general',
                defects: 'Alteraciones',
                contextAndSignatures: 'Antecedentes y firmas',
                documentReady: '¡Documento listo!'
            },
            title: 'Resumen'
        },
        pdfDocument: {
            mainTitlePrefix: 'INFORME DE ESTADO - ',
            objectSection: {
                sectionTitle: 'Objeto',
                inventoryNumber: 'Nº de inventario : ',
                title: 'Título: ',
                author: 'Artista / Autor :',
                creationDate: 'Fecha de creación : ',
                typology: 'Tipología: ',
                denomination: 'Nombre: ',
                materialsAndTechniques: 'Materiales y técnicas :',
                dimensions: 'Dimensiones: ',
                institution: 'Institución:'
            },
            alterationsSection: {
                detailedAlteration: 'Alteración detallada',
                noAnnotation: 'No hay anotaciones que mostrar',
                observationLabel: 'Obs.',
                sectionTitle: 'Detalles de las alteraciones'
            },
            finalObservationsSection: { sectionTitle: 'Observaciones finales' },
            contextSection: {
                comments: 'Comentarios :',
                matAndTechs: 'Materiales y técnicas :',
                reportDate: 'Fecha del hallazgo :',
                reportPlace: 'Ubicación: ',
                reportReference: 'Referencia del informe :',
                sectionTitle: 'Antecedentes de este informe de situación',
                reportType: 'Tipo de hallazgo : ',
                reportReason: 'Motivo del hallazgo: '
            },
            reportSection: {
                interventionsToSchedule: 'Intervenciones a planificar : ',
                sectionTitle: 'Informe',
                signatoriesTitle: 'Observación realizada en presencia de :',
                stateOfConservation: 'Estado de la propiedad: ',
                treatmentPriority: 'Prioridad de tratamiento : '
            },
            footer: { prefix: 'DECLARACIÓN DE CONDICIONES', separator: '- Página' }
        },
        proxy: {
            error: {
                default: 'Se ha producido un error en el recurso {uri}',
                network: 'La comunicación con el servidor ha fallado',
                notFound: 'No se ha encontrado el recurso {uri}',
                tokenHasExpired: 'Su sesión ha expirado'
            }
        },
        search: {
            noResults: 'No hay resultados',
            options: {
                sortType: {
                    creationDate: 'Fecha de creación',
                    identifier: 'Identificador principal',
                    lastModification: 'Última modificación',
                    mainTitle: 'Título principal',
                    referenceNumber: 'Número de referencia'
                }
            },
            queryPlaceholder: 'Palabras clave o número de inventario',
            title: 'Objetos de museo',
            totalCount: '{totalResults} Resultado(s) : 1 -'
        },
        searchFeaturedCard: {
            createNewReport: 'CREAR UNA NUEVO INFORME',
            createNewReportFromLast: 'DECLARACIÓN DEL ÚLTIMO INFORME',
            institutionLabel: 'Institución',
            lastReportLabel: 'Último informe de estado',
            materialsAndTechniques: 'Materiales / Técnicas',
            measurements: 'Dimensiones',
            noLinkedItem: 'No hay artículos relacionados con este informe de estado'
        },
        serviceWorker: {
            updateAvailable: 'Se ha instalado una actualización. Pulse aquí para recargar la página o reiniciar la aplicación'
        },
        signatureModuleScreen: {
            cardTitle: 'Firmante',
            eraseSignature: 'Firma de nuevo',
            missingSignature: 'Falta la firma',
            nameLabel: 'Apellido / Nombre',
            presentSignature: 'Firma presente',
            saveSignature: 'Registro',
            signatureStatus: 'Estado de la firma',
            title: 'Firmas'
        }
    }
};

export const dateTimeFormats = {
    fr: {
        short: {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        },
        shortTime: {
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            month: '2-digit',
            second: 'numeric',
            year: 'numeric',
        },
        year: {
            year: 'numeric',
        },
    },
};
